// extracted by mini-css-extract-plugin
module.exports = {"markdown":"MarkdownText_markdown__2kFWG","highlight":"MarkdownText_highlight__AzEuB"};